export const pageSizeItems = [
  { id: 20, label: '20 résultats par page' },
  { id: 50, label: '50 résultats par page' },
  { id: 100, label: '100 résultats par page' },
]
